import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { BONUS_PRICE } from '../../../constants/defaults';
import _ from 'lodash';

const DisclaimerData = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="disclaimerDataSection">
      <div className="disclaimerData">
        <div className="disclaimerInfo">
          <h2>{t('About SingleCare Pricing')}</h2>
          <p>{t('disclaimerDataDescription')}</p>
          <p>
            {t('disclaimerDataDescriptionNew', { bonusPrice: BONUS_PRICE })}
          </p>
          <p className="priceUpdatedDate">
            {t('Prices updated')}{' '}
            {_.getNewFormattedDate(
              new Date(),
              _.isEqual(i18n.language, 'es') ? 'DD/MM/YYYY' : ''
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
export default DisclaimerData;
